import { Flex } from '@pancakeswap/uikit'
import styled from 'styled-components'
import Results from './Results'
import TypeFilter from './TypeFilter'

const Wrapper = styled(Flex)`
  display: flex;
  padding: 0px 16px;
  align-items: flex-start;
  gap: 16px;
  flex: 1 0 0;
  align-self: stretch;
  overflow-y: auto;
`

const Border = styled(Flex)`
  width: 1px;
  flex-shrink: 0;
  align-self: stretch;
  background: rgba(255, 255, 255, 0.1);
`

interface SearchResultProps {
  activeFilter: number
  onClickFilter: (index: number) => void
}

const SearchResult = ({ activeFilter, onClickFilter }: SearchResultProps) => {
  return (
    <Wrapper>
      <TypeFilter activeFilter={activeFilter} onClickFilter={onClickFilter} />
      <Border />
      <Results />
    </Wrapper>
  )
}

export default SearchResult
